var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00003 4.60003C1.00003 4.26866 1.26866 4.00003 1.60003 4.00003H18.4C18.7314 4.00003 19 4.26866 19 4.60003C19 4.9314 18.7314 5.20003 18.4 5.20003H1.60003C1.26866 5.20003 1.00003 4.9314 1.00003 4.60003ZM4.00002 9.60003C4.00002 9.26866 4.26864 9.00003 4.60002 9.00003H15.4C15.7314 9.00003 16 9.26866 16 9.60003C16 9.9314 15.7314 10.2 15.4 10.2H4.60002C4.26864 10.2 4.00002 9.9314 4.00002 9.60003ZM7.60002 14C7.26864 14 7.00002 14.2687 7.00002 14.6C7.00002 14.9314 7.26864 15.2 7.60002 15.2H12.4C12.7314 15.2 13 14.9314 13 14.6C13 14.2687 12.7314 14 12.4 14H7.60002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.3221ac0f790087a58646c26f0e33c1fe.svg";
export { ForwardRef as ReactComponent };